import { Box, css, Tab, TabList, TabPanels, Tabs, Text, VStack } from '@chakra-ui/react';
import { PropsWithChildren, cloneElement, useEffect } from 'react';
import { useTheme } from '../../../../../packages/ui/contexts/ThemeProvider';
import { setBrowserThemeColor } from '../../../../../packages/ui/utils';

export interface ITopBookstoreMenuTab {
  name: string;
  icon: JSX.Element;
}

export function TopBookstoreMenu({
  selectedTab = 0,
  tabs,
  children,
}: {
  selectedTab?: number;
  tabs: ITopBookstoreMenuTab[];
} & PropsWithChildren) {
  const { colors, isIOS, isNative } = useTheme();

  useEffect(() => {
    setBrowserThemeColor(colors.primaryColor);
  }, [colors]);

  return (
    <Box transform={isIOS ? 'translateY(-45px)' : ''} minW={'100vw'} maxW={'100vw'}>
      <Tabs isLazy colorScheme="whiteAlpha.900" defaultIndex={selectedTab}>
        <TabList
          overflowX={'auto'}
          minW={'100vw'}
          maxW={'100vw'}
          paddingX={{
            base: 2,
            md: '5%',
          }}
          css={css({
            scrollbarWidth: 'none',
            '::-webkit-scrollbar': { display: 'none' },
            WebkitOverflowScrolling: 'touch',
            border: 'none',
          })}
          paddingBottom={'2px'}
          paddingTop={isNative ? '0px' : '10px'}
          backgroundColor={'primaryColor'}
          color="white"
        >
          {tabs.map((tab, i) => (
            <Tab
              key={i}
              _selected={{ border: '0px', borderBottom: '2px solid white', borderRadius: '0px' }}
              marginRight={'0px'}
              w={'fit-content'}
              padding="10px 10px"
              paddingBottom={'5px'}
            >
              <VStack spacing={1}>
                {cloneElement(tab.icon, { fontSize: '22px' })}
                <Text
                  fontSize={{
                    base: '15px',
                    md: '16px',
                  }}
                  whiteSpace={'nowrap'}
                >
                  {tab.name}
                </Text>
              </VStack>
            </Tab>
          ))}
        </TabList>

        <TabPanels>{children}</TabPanels>
      </Tabs>
    </Box>
  );
}
